import { set } from "date-fns/esm";

const validateEmail = ({ email, setEmailError }) => {
  const emailRegular =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email && !email.match(emailRegular)
    ? setEmailError('Email not valid')
    : setEmailError('');
};

const validateAddress = ({ address, setAddressError }) => {
  return address && address.length < 5
    ? setAddressError('Full name is too short')
    : address && address.length > 50
      ? setAddressError('Try to make short and meanfull')
      : setAddressError('');

};

const validateFullName = ({ fullName, setFullNameError }) => {
  return fullName && fullName.length < 5
    ? setFullNameError('Full name is too short')
    : fullName && fullName.length > 50
      ? setFullNameError('Try to make short and meanfull')
      : setFullNameError('');
};

const validateMessage = ({ message, setMessageError }) => {
  return message && message.length < 5
    ? setMessageError('Message is too short')
    : message && message.length > 200
      ? setMessageError('Try to make short and meanfull')
      : setMessageError('');
};

export { validateEmail, validateFullName, validateMessage, validateAddress };